import axios from "axios";
import { ajaxUri } from "../../../consts/index";
import { l } from "../../../functions";

export const fetchThemes = (loadIncrement = null) => {
  return (dispatch) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "listThemes",
      },
    })
      .then((result) => {
        if (loadIncrement)
          dispatch({ type: "LOAD_INCREMENT", toAdd: parseInt(loadIncrement) });

        dispatch({ type: "LIST_THEMES", themes: result.data });
      })
      .catch((error) => {
        console.error(l("Cannot fetch themes"));
      });
  };
};

export const addThemeThumb = (themeName, url, loadIncrement = null) => {
  return (dispatch) => {
    dispatch({ type: "ADD_THEME_THUMB", data: { themeName, url } });
  };
};

export const selectedTheme = () => {
  return (dispatch) => {
    axios({
      method: "POST",
      url: ajaxUri,
      data: {
        request: "getSelectedThemeName",
      },
    })
      .then((res) => {
        dispatch({
          type: "CURRENT_THEME",
          currentTheme: res.data?.selectedTheme || null,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
